<div class="modal-header">
    <div class="text-xl heavy text-primary">Tredder Rally</div>
    <button class="btn-close" type="button" data-dismiss="modal" aria-label="Close" (click)="activeModal.close()"></button>
</div>
<div class="modal-body">
    <div class="text-lg text-primary mb-2">Goal</div>
    <div class="mb-1">The higher you go and the faster you spin (to a point), the more points!</div>
    <div class="text-lg text-primary mb-2">Mobile</div>
    <div class="mb-1">&bull; Press right side of screen to rotate forward</div>
    <div class="mb-1">&bull; Press left side of screen to rotate backward</div>
    <div class="text-lg text-primary mb-2">Desktop</div>
    <div class="mb-1">&bull; Press right arrow to rotate forward</div>
    <div class="mb-1">&bull; Press left arrow to rotate backward</div>
    <div class="text-primary mt-3 mb-3">
        Tredder insures your Custom Modifications,
        <div class="d-inline-block me-1">Aftermarket Parts,</div>
        <div class="d-inline-block me-1">Personal Property,</div>
        <div class="d-inline-block">and more!</div>
    </div>
    <div class="mb-3">
        <div class="italic d-inline me-2">Find out more at</div>
        <div class="text-primary d-inline pointer" (click)="goHome()">tredder.com</div>
    </div>
    <div class="d-grid mb-3"><button class="btn btn-lg btn-secondary fw-500" data-cy="playGameButton" type="button" (click)="play()">Start Game!</button></div>
</div>
